import { render, staticRenderFns } from "./SelectRole.vue?vue&type=template&id=34dc5ad8"
import script from "./SelectRole.vue?vue&type=script&lang=ts"
export * from "./SelectRole.vue?vue&type=script&lang=ts"
import style0 from "./SelectRole.vue?vue&type=style&index=0&id=34dc5ad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports